export var NotificationTypeList = [
    "optionMinting",
    "optionSale",
    "withdrawalReady",
];
//# sourceMappingURL=notification.js.map